import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEProductionCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Production Engineering",
    shortName: "B.E. Production",
    duration: "4 years",
    description: "Engineering program focused on manufacturing processes, production planning, and industrial management",
    overview: "Bachelor of Engineering in Production Engineering (B.E. Production) is a 4-year undergraduate program that combines mechanical engineering with industrial engineering and management principles. This course covers manufacturing processes, production planning, quality control, automation, and lean manufacturing, preparing students for careers in manufacturing and production industries.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in manufacturing and industrial processes"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Workshop Technology",
          "Programming in C"
        ]
      },
      {
        year: 2,
        subjects: [
          "Strength of Materials",
          "Thermodynamics",
          "Manufacturing Processes",
          "Material Science",
          "Fluid Mechanics",
          "Machine Drawing"
        ]
      },
      {
        year: 3,
        subjects: [
          "Production Planning & Control",
          "Industrial Engineering",
          "Quality Control",
          "Tool Design",
          "Automation in Manufacturing",
          "Operations Research"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Manufacturing",
          "Lean Manufacturing",
          "Supply Chain Management",
          "Project Management",
          "Industrial Safety",
          "Project Work"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Production Engineer",
        "Manufacturing Engineer",
        "Quality Engineer",
        "Process Engineer",
        "Industrial Engineer",
        "Production Manager",
        "Operations Manager",
        "Supply Chain Manager",
        "Plant Manager",
        "Project Manager"
      ],
      industries: [
        "Automotive Manufacturing",
        "Aerospace Industry",
        "Electronics Manufacturing",
        "Textile Industry",
        "Pharmaceutical Manufacturing",
        "Steel and Metal Industry",
        "Consumer Goods",
        "Heavy Engineering",
        "Defence Manufacturing",
        "Process Industries"
      ],
      averageSalary: "₹4-8 LPA (Fresher), ₹12-30 LPA (Experienced)",
      topRecruiters: [
        "Maruti Suzuki, Tata Motors",
        "L&T, BHEL, Kirloskar",
        "Bajaj Auto, TVS Motors",
        "Godrej, ITC",
        "Mahindra & Mahindra",
        "Ashok Leyland, Force Motors"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "College of Engineering Guindy, Anna University",
        location: "Chennai",
        fees: "₹2,00,000",
        ranking: "NIRF Ranking: 35"
      },
      {
        name: "National Institute of Technology",
        location: "Tiruchirappalli",
        fees: "₹6,50,000",
        ranking: "NIRF Ranking: 9"
      },
      {
        name: "PSG College of Technology",
        location: "Coimbatore",
        fees: "₹4,50,000",
        ranking: "NIRF Ranking: 42"
      },
      {
        name: "Annamalai University",
        location: "Chidambaram",
        fees: "₹3,00,000",
        ranking: "State University"
      }
    ],

    skills: [
      "Production Planning",
      "Quality Management",
      "Lean Manufacturing",
      "Process Optimization",
      "Industrial Automation",
      "CAD/CAM",
      "Project Management",
      "Supply Chain Management",
      "Statistical Process Control",
      "Leadership and Management"
    ],

    futureScope: "Excellent growth prospects with Industry 4.0, smart manufacturing, automation technologies, and sustainable production methods driving demand for production engineers.",

    faqs: [
      {
        question: "What is the difference between Production and Mechanical Engineering?",
        answer: "Production Engineering focuses more on manufacturing processes, production planning, and industrial management, while Mechanical Engineering covers broader mechanical systems design and analysis."
      },
      {
        question: "Are there good opportunities in the automotive industry?",
        answer: "Yes, automotive industry offers excellent opportunities for production engineers in manufacturing operations, quality control, and process improvement roles."
      },
      {
        question: "Can production engineers work in management roles?",
        answer: "Yes, production engineers often progress to management positions like production manager, operations manager, and plant manager due to their technical and management knowledge."
      },
      {
        question: "What about opportunities in automation?",
        answer: "Excellent opportunities exist in industrial automation, smart manufacturing, robotics integration, and Industry 4.0 implementations across various industries."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEProductionCoursePage;
